export default  {
    bindings: {
        'large': '<',
        'tiny': '<'
    },
    template: require('../views/spinner.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/components/spinner.component.js